import { Suspense } from 'react';

import { Text } from '@iwoca/orion';
import { Skeleton } from '@ui';

import { FundingProgressIndicator } from './components/FundingProgressIndicator/FundingProgressIndicator';
import { DesktopLoanSummary } from './components/LoanSummary/DesktopLoanSummary';
import { MobileLoanSummary } from './components/LoanSummary/MobileLoanSummary';
import { useFundingRequirementsParams } from './hooks/useFundingRequirementsParams';
import { useGetFormalOffer } from './hooks/useGetFormalOffer';
import { ErrorBoundary } from '../../../../../../errorBoundary/ErrorBoundary';
import FallbackErrorModal from '../../../../../modals/fallbackErrorModal/FallbackErrorModal';
import { FundingRequirementsPageShell } from '../../components/FundingRequirementsPageShell';

export const FundingRequirementsPage = () => {
    return (
        <ErrorBoundary fallback={() => <FallbackErrorModal />}>
            <Suspense
                fallback={
                    <div className="space-y-s">
                        <Skeleton className="h-m w-full" />
                        <Skeleton className="h-xl w-full" />
                    </div>
                }
            >
                <FundingRequirementsPageContent />
            </Suspense>
        </ErrorBoundary>
    );
};

const FundingRequirementsPageContent = () => {
    const { offerId, drawdownAmount } = useFundingRequirementsParams();
    const formalOffer = useGetFormalOffer(offerId);

    return (
        <FundingRequirementsPageShell
            sidePanel={
                <DesktopLoanSummary
                    formalOffer={formalOffer}
                    drawdownAmount={drawdownAmount}
                />
            }
            progressIndicator={<FundingProgressIndicator />}
            mainContent={
                <>
                    <div className="min-m:hidden">
                        <MobileLoanSummary
                            formalOffer={formalOffer}
                            drawdownAmount={drawdownAmount}
                        />
                    </div>
                    <div data-testid="requirements-list">
                        <Text>Requirements list placeholder</Text>
                    </div>
                </>
            }
        />
    );
};
